import { render, staticRenderFns } from "./AdminCreateDashComponent.vue?vue&type=template&id=8d0a5cec&scoped=true"
import script from "./AdminCreateDashComponent.vue?vue&type=script&lang=js"
export * from "./AdminCreateDashComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0a5cec",
  null
  
)

export default component.exports